<template>
  <div class="chart-page">
    <v-row>
      <v-col cols="4" sm="4" class="paddintp0">
        <div class="multi-drop">
          <multi-select
            allText="All Subjects"
            :items="subjects"
            :onChange="getSubjectScores"
            label="Select Subject"
            class="select-sub"
            dense
            hide-details
            filled
          ></multi-select>
        </div>
      </v-col>
      <v-col cols="4" sm="4" class="paddintp0"></v-col>
      <!-- <v-col cols="4" sm="4" class="paddintp0">
                <div class="chart-top-btn-how">
                    <v-btn @click="howItWorks" class="how-sub-btn" outlined>How This Works</v-btn>
                </div>
            </v-col>-->
    </v-row>
    <v-row v-if="series.length > 0">
      <v-col cols="12" sm="12" class="paddintp0">
        <div id="chart" class="snchart performance-chart">
          <!-- <apexchart type="bar" height="500" :options="chartOptions" :series="series"></apexchart> -->
          <BarChart :seriesData="series" :chartOptions="chartOptions" />

          <div class="number-of0que">Number of Questions</div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" class="paddintp0-1">
        <div class="chart-indicator">
          <div class="indicator-block">
            <div class="indicator-color institute-avg-marks"></div>
            <div class="indicator-text">Correct</div>
          </div>
          <div class="indicator-block">
            <div class="indicator-color batch-high"></div>
            <div class="indicator-text">Incorrect</div>
          </div>
          <div class="indicator-block">
            <div class="indicator-color unanswered"></div>
            <div class="indicator-text">Unanswered</div>
          </div>
          <div class="indicator-block">
            <div class="indicator-color your-marks"></div>
            <div class="indicator-text">Partially Correct</div>
          </div>
        </div>
      </v-col>
    </v-row>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import BarChart from "@/components/Charts/BarChart.vue";

export default {
  name: "ChapterWisePerformance",
  components: {
    BarChart,
  },
  props: ["studentId"],

  mounted() {
    this.getSubjects();
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  data() {
    return {
      cComponent: "components/coordinator/AddBatch",
      alertBoxData: {},
      status: false,
      modalwidth: "70%",
      subjects: [],
      selectedSubject: null,
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: "150px",
          // width: "100%",
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            // columnWidth: "100%",
            barHeight: "50",
          },
        },
        stroke: {
          width: 0,
          colors: ["#fff"],
        },
        grid: {
          show: false,
        },
        states: {
          hover: {
            filter: {
              type: "none",
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: "13px",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label-rl",
            },
          },
        },

        fill: {
          colors: ["#96ea96", "#ff7373", "#dcdcdc", "#869fe2"],
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          textAnchor: "end",
          style: {
            colors: ["#000"],
          },
        },
      },
    };
  },
  methods: {
    ...mapActions({
      getTestSubjects: "resultStore/getTestSubjects",
      getSubjectBatchWise: "resultStore/getSubjectBatchWise",
      getDataForChapterWisePerformance:
        "resultStore/getDataForChapterWisePerformance",
    }),
    howItWorks() {
      this.cComponent = "components/student/HowItWorks";
      this.alertBoxData = {
        image: "chapterwise",
      };
      this.modalwidth = "70%";
      this.status = true;
      this.$forceUpdate();
    },
    onClose(data) {
      this.status = data.status;
    },
    getSubjectTestWise() {
      let test_id = this.$route.params.test_id;
      let reqData = { test_id, student_id: this.studentId };
      this.$root.showLoader = true;
      this.getTestSubjects(reqData)
        .then((response) => {
          this.subjects = response.map((s) => {
            return {
              text: s.title,
              value: { subject_id: s.id },
              checked: false,
            };
          });
          this.subjects[0].checked = true;
          let selectedSubject = [this.subjects[0].value];
          this.getSubjectScores(selectedSubject);

          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    getBatchId() {
      let batchId = null;
      if (this.user.students)
        this.user.students.map((student) => {
          if (student.id == this.studentId) {
            batchId = student.batch_id;
          }
        });
      if (!batchId) {
        batchId = this.$route.params.batch_id;
      }
      return batchId;
    },
    getSubjectsBatchWise() {
      let batch_id = this.user.batch_id;
      if (this.user.role_id == this.roleIds.PA) {
        batch_id = this.getBatchId();
        if (!batch_id) {
          this.$toasted.error("Error getting Batch Id");
        }
      }
      if (!batch_id) {
        batch_id = this.getBatchId();
      }
      let reqData = { batch_id, student_id: this.studentId };
      this.$root.showLoader = true;
      this.getSubjectBatchWise(reqData)
        .then((response) => {
          this.subjects = response.map((s) => {
            return {
              text: s.title,
              value: { subject_id: s.id },
              checked: false,
            };
          });
          this.subjects[0].checked = true;
          let selectedSubject = [this.subjects[0].value];
          this.getSubjectScores(selectedSubject);

          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    getSubjects() {
      let routeName = this.$route.name;
      //   console.log(routeName);
      if (
        routeName == "cumulative-analysis" ||
        routeName == "cumulative-analysis-coordinator"||
		routeName == "cumulative-analysis-director"
      ) {
        this.getSubjectsBatchWise();
      } else {
        this.getSubjectTestWise();
      }
    },
    getSubjectScores(selectedSubject) {
      let testId = this.$route.params.test_institute_id;
      let subjects = selectedSubject.map((subject) => subject.subject_id);
      this.series = [];

      if (subjects.length > 0) {
        let postData = {
          subjects: subjects,
          test_institute_id: testId,
          student_id: this.studentId,
        };
        this.$root.showLoader = true;
        this.getDataForChapterWisePerformance(postData)
          .then((response) => {
            if (response.length > 0) {
              this.processScoreChapterWise(response);
            }
            this.$root.showLoader = false;
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    processScoreChapterWise(response) {
      let series = [
        {
          name: "Correct",
          data: [],
        },
        {
          name: "Incorrect",
          data: [],
        },
        {
          name: "Unanswered",
          data: [],
        },
        {
          name: "Partially Correct",
          data: [],
        },
      ];
      let chapters = [];
      response.forEach((c) => {
        chapters.push(c.title);
        series[0].data.push(c.correct);
        series[1].data.push(c.incorrect);
        series[2].data.push(c.unattempted);
        series[3].data.push(c.partially_correct);
      });
      let that = this;
      let tooltip = {
        // followCursor: true,
        // custom: function({ series1, seriesIndex, dataPointIndex, w }) {
        //     return (
        //         "<div class='bar-tooltip'><div class='responce-tooltip'>" +
        //         "<span class='normal-text-data'>" +
        //         w.globals.labels[dataPointIndex] +
        //         "<br>" +
        //         that.series[seriesIndex].name +
        //         "</span>" +
        //         "</div></div>"
        //     );
        // }
        enabled: true,
        marker: {
          show: false,
        },
      };
      this.series = series;
      this.chartOptions.xaxis.categories = chapters;
      this.chartOptions.tooltip = tooltip;
      if (chapters.length > 2)
        this.chartOptions.chart.height = chapters.length * 60 + "px";
      else this.chartOptions.chart.height = "150px";
    },
  },
};
</script>
